import React from 'react';
import tablecss from "../../css/table.module.css";

const PageWithSubTables = () => {
  const columns = ['PARTICULARS', 'NOTES', 'AS AT Dec 15TH, 2024', 'AS AT Dec 15TH, 2023'];

  const subTables = [
    {
      data: [
        { particulars: 'Financial Assets', notes: 2, amount1: "12,50,000", amount2: "10,25,000" },
        { particulars: 'Data', notes: 2, amount1: "Data", amount2: "Data" },
        { particulars: 'Data', notes: 2, amount1: "Data", amount2: "Data" },
        { particulars: 'Data', notes: 2, amount1: "Data", amount2: "Data" },
        { particulars: 'Data', notes: 2, amount1: "Data", amount2: "Data" },
      ],
    },
    {
      data: [
        { particulars: 'Financial Assets', notes: 2, amount1: "12,50,000", amount2: "10,25,000" },
        { particulars: 'Data', notes: 2, amount1: "Data", amount2: "Data" },
        { particulars: 'Data', notes: 2, amount1: "Data", amount2: "Data" },
        { particulars: 'Data', notes: 2, amount1: "Data", amount2: "Data" },
        { particulars: 'Data', notes: 2, amount1: "Data", amount2: "Data" },
      ],
    },
  ];

  return (
    <div className={tablecss.tableContainer}>
      <table className={tablecss.templateCustomTable}>
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th key={index}>{col}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {subTables.map((table, tableIndex) => (
            <React.Fragment key={tableIndex}>
              {/* Render table rows */}
              {table.data.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  className={rowIndex === 0 ? tablecss.firstRow : ''}
                >
                  <td>{row.particulars}</td>
                  <td>{row.notes}</td>
                  <td>{row.amount1}</td>
                  <td>{row.amount2}</td>
                </tr>
              ))}

              {/* Add gap after each table except the last one */}
              {tableIndex !== subTables.length - 1 && (
                <tr>
                  <td className={tablecss.emptyRow} colSpan={4}></td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PageWithSubTables;
